import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MarkSubmissionConfirmModal from "../MarkSubmission/MarkSubmissionConfirmModal";
import { useSubject } from "../../context/SubjectContext";
import { useCenter } from "../../context/CenterContext";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { useConsortiaCenter } from "../../context/ConsortiaCenterContext";
import {
  useModerationWindowSession,
  MARK_STATUS,
} from "../../constants/Constants";
import { handleDownloadStage3,getCenterType, checkunitIsConsortiaUnit } from "../../utils/utils";

import { useApi } from "../../context/ApiClient";

const ACUpdateMarksViewHeader = ({
  onSubmitClicked,
  showModal,
  setShowModal,
  rows,
  candidates,
  isRowComplete,
  onManualSaveSuccess,
  lastSavedAt,
  isStage3,
  isPostStage3
}) => {
  const moderationWindowSession = useModerationWindowSession();
  const api = useApi(process.env.REACT_APP_AMS_BASE_URL);
  const [isChecked, setIsChecked] = useState(false);
  const location = useLocation();
  const { subjectData } = useSubject();
  const { selectedSubject, selectedSubjectCode , selectedSubjectId} = subjectData || {};
  const subjectId = subjectData?.selectedSubjectId;
  const {
    unit,
    sessionId,
    sessionStartDate,
    sessionEndDate,
    visitDate,
    additionalVisitDate,
    statusType,
  } = location.state || {};
    const { consortiaCentres = [] } = useConsortiaCenter();
    const { centerNumber, centerName, centres } = useCenter();
const consortiaUnitcode =
    String(unit ?? "")
      .toUpperCase()
      .match(/^[A-Z0-9]+/)?.[0] || "";
   const currentCentreType = getCenterType(
        consortiaCentres,
        Number(centerNumber),
        selectedSubject,
        selectedSubjectId
      ) || '';
         const isConsortiaUnit = checkunitIsConsortiaUnit(
                             consortiaCentres,
                             centerNumber,
                             sessionId,
                             consortiaUnitcode,
                           );
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(`/dashboard/marks_submission/${selectedSubject}`);
  };

  const getSessionDetails = (sessionStartDate, sessionEndDate, sessionId) => {
    const academicYear = `${new Date(sessionStartDate).getFullYear()}/${String(
      new Date(sessionEndDate).getFullYear()
    ).slice(-2)}`;
    return sessionId === moderationWindowSession.window1
      ? `Window 1 (February series) - ${academicYear}`
      : sessionId === moderationWindowSession.window2
      ? `Window 2 (June series) - ${academicYear}`
      : "";
  };

  const onClose = () => {
    setShowModal(false);
    setIsChecked(false);
  };
  const formatDate = (dateStr) => {
    if (!dateStr) return ""; // or return "N/A", depending on what you want

    const date = new Date(dateStr);
    if (isNaN(date)) return ""; // handle invalid date strings

    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <>
      <MarkSubmissionConfirmModal
        isOpen={showModal}
        onClose={onClose}
        rows={rows}
        isChecked={isChecked}
        setIsChecked={setIsChecked}
        type="marks"
        isStage3={isStage3}
      />
      <hr className="my-2" />
      <div
        className="xcard unit-header mt-2 xp-4 xhas-shadow-2 is-flex is-justify-content-space-between mb-4 is-align-items-center"
        style={{ backgroundColor: "#FFFFFF" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            textAlign: "left",
          }}
        >
          <div className="is-size-6">
            {(["Visit Confirmed", "Visit Completed"].includes(statusType) || isStage3) && (
              <>
                <strong>Visit date: { formatDate(visitDate)}</strong> |{" "}
              </>
            )}
            {statusType === "Visit Requested" && !isStage3 && (
              <>
                <strong>Visit requested</strong> |{" "}
              </>
            )}
            {getSessionDetails(sessionStartDate, sessionEndDate, sessionId)}
          </div>
<>
               {additionalVisitDate && (
                <div className="is-flex is-align-items-center">
                  <span className="icon mr-1">
                    <svg
                      style={{ fill: "#a55900" }}
                      xmlns="http://www.w3.org/2000/svg"
                      height="24px"
                      viewBox="0 -960 960 960"
                      width="24px"
                      fill="212121"
                    >
                      <path d="m560-120-57-57 144-143H200v-480h80v400h367L503-544l56-57 241 241-240 240Z" />
                    </svg>
                  </span>
                  <span className="pt-1">
                    <strong style={{ color: "#a55900" }}>
                      {`Additional visit: ${formatDate(additionalVisitDate)}`}
                    </strong>
                  </span>
                </div>
              )}
              </>
          <div className="is-size-5">
            <strong>{unit}</strong>
          </div>
        </div>
        <div>
          <div>
            <div className="field is-grouped">
              <div className="tags has-addons mr-0">
                <span className="tag is-success view-submit-color mt-3">
                  ✔ Total marks updated
                </span>
              </div>
              <button
                className="button is-text is-outlined mr-2"
                onClick={handleBack}
              >
                <span className="icon mr-2">
                  <svg
                    style={{ fill: "#0076BD" }}
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 -960 960 960"
                    width="24"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <path d="M560-253.847 333.847-480 560-706.153 602.153-664l-184 184 184 184L560-253.847Z"></path>
                  </svg>
                </span>
                Back
              </button>
              <button
                className="button is-primary is-outlined mr-2"
                onClick={() =>
                  handleDownloadStage3(
                    rows,
                    "UpdatedViewTotalMarks",
                    location,

                    { centerNumber, centerName },
                    subjectData,
                    api,
                    {},
                    isPostStage3,
                    currentCentreType,isConsortiaUnit,centres,isStage3,
                    moderationWindowSession
                  )
                }
              >
                Download
              </button> 
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ACUpdateMarksViewHeader;
